// extracted by mini-css-extract-plugin
export var feature = "+vL2P";
export var icon = "QSBiA";
export var isCompact = "RbBoY";
export var main = "_4qLvq";